import z from "zod";

export const sendWelcomePtMessageFormSchema = z.object({
  stationId: z.number().int(),
});

export type SendWelcomePtMessageFormValues = z.infer<
  typeof sendWelcomePtMessageFormSchema
>;
